export const authConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_SSO_USER_FLOW,
        knownAuthorities: process.env.REACT_APP_SSO_AUTHORITY.split(","),
        redirectUri: process.env.REACT_APP_SSO_SIGN_IN_REDIRECT_URL,
        postLogoutRedirectUri: process.env.REACT_APP_SSO_SIGN_OUT_REDIRECT_URL
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    },
};

export const loginRequest = {
    scopes: [process.env.REACT_APP_CLIENT_ID] // the scope for login should be the client app, the scope for API usage should be the server token
};

export const vegasTokenScopes = {
    scopes: process.env.REACT_APP_TOKEN_SCOPES.split(",")
};